import React from "react";
import { toast } from "sonner";
import { FacebookLogoIcon, XLogoIcon, LinkedinLogoIcon, WhatsappLogoIcon, LinkSimpleIcon } from "@phosphor-icons/react";

export const ShareButtons = ({ url, text = "", size = 16, tone = "dark", className = "" }) => {
  const u = encodeURIComponent(url || "");
  const t = encodeURIComponent(text || "");
  const targets = [
    { key: "facebook", label: "Share on Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, Icon: FacebookLogoIcon },
    { key: "x", label: "Share on X", href: `https://twitter.com/intent/tweet?text=${t}&url=${u}`, Icon: XLogoIcon },
    { key: "linkedin", label: "Share on LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, Icon: LinkedinLogoIcon },
    { key: "whatsapp", label: "Share on WhatsApp", href: `https://wa.me/?text=${t}%20${u}`, Icon: WhatsappLogoIcon },
  ];
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(url || ""); toast.success("Link copied to clipboard"); }
    catch { toast.error("Could not copy link"); }
  };
  const base = tone === "dark"
    ? "text-slate-300 hover:text-white hover:bg-navy-800"
    : "text-slate-500 hover:text-gold-600 hover:bg-slate-100";
  return (
    <div data-testid="share-buttons" className={`flex items-center gap-1 ${className}`}>
      {targets.map(({ key, label, href, Icon }) => (
        <a
          key={key}
          data-testid={`share-${key}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          className={`w-8 h-8 rounded-sm flex items-center justify-center transition-colors ${base}`}
        >
          <Icon size={size} weight="fill" />
        </a>
      ))}
      <button
        type="button"
        data-testid="share-copy"
        onClick={copyLink}
        aria-label="Copy link"
        title="Copy link"
        className={`w-8 h-8 rounded-sm flex items-center justify-center transition-colors ${base}`}
      >
        <LinkSimpleIcon size={size} weight="bold" />
      </button>
    </div>
  );
};
